export default __webpack_public_path__ + "static/media/growth_icon3.e8ee7335.svg";